<template>
  <div class="ui grid">
    <div class="row">
      <h3 class="ui huge header">Unpaid invoices</h3>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <span>The total outstanding balance is&nbsp;
        {{ formatAsPrice(totalBalance) }}, of which&nbsp;
        {{ formatAsPrice(overdueBalance) }} is overdue</span>
    </div>
    <div class="row">
      <span>The total owed VAT (once invoices are paid) is&nbsp;
        {{ formatAsPrice(totalVat) }}</span>
    </div>
    <div class="row">
      <sui-button type="button" primary v-on:click="generateReport">
        Download report
      </sui-button>
    </div>
    <div class="row">
      <invoices-table v-bind:licenses="licenses" v-bind:actions="licensesActions" v-on:rowAction="rowAction"
        show-school="true" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InvoicesTable from '@/components/invoices/InvoicesTable';
import moment from 'moment';
import schoolsApi from '@/api/schools';

export default {
  name: 'UnpaidInvoices',
  components: { InvoicesTable },
  computed: {
    totalBalance() {
      return this.licenses.reduce(
        // eslint-disable-next-line no-return-assign
        (total, license) => (total += license.balance),
        0,
      );
    },
    totalVat() {
      return this.licenses.reduce(
        // eslint-disable-next-line no-return-assign
        (total, license) => (total += license.vat),
        0,
      );
    },
    overdueBalance() {
      return this.licenses
        .filter(
          // eslint-disable-next-line arrow-parens
          (license) =>
            moment(license.dueAt).diff(this.currentDate, 'days') <= 0,
        )
        .reduce(
          // eslint-disable-next-line no-return-assign
          (total, license) => (total += license.balance),
          0,
        );
    },
    ...mapGetters({
      licenses: 'licenses',
    }),
  },
  data() {
    return {
      licensesActions: ['View'],
    };
  },
  methods: {
    formatAsPrice(value) {
      const formattedNumber = value.toFixed(2);
      const [integerPart, decimalPart] = formattedNumber.split('.');

      const formattedInteger = parseInt(integerPart, 10).toLocaleString(
        undefined,
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        },
      );

      return `€${formattedInteger}${decimalPart ? '.' : ''}${decimalPart || ''
        }`;
    },
    rowAction(action) {
      if (action.action === 'View') {
        // eslint-disable-next-line arrow-parens
        const license = this.licenses.find((l) => l.id === action.id);
        this.$router.push(`/school/details/${license.schoolId}?return=unpaid`);
      }
    },
    generateReport() {
      this.$store.dispatch('showLoader');
      schoolsApi
        .generateUnpaidLicensesReport(
          ['perstudent', 'fixedprice', 'other']
        )
        .then((response) => {
          const blob = new Blob([response.data], { type: response.data.type });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'unknown';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+);/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1].replaceAll('"', '');
            }
          }
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .finally(() => {
          this.$store.dispatch('hideLoader');
        });
    },
  },
  created() {
    this.$store.dispatch('getUnpaidLicenses', {
      licenseModels: ['perstudent', 'fixedprice', 'other']
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/invoices/UnpaidInvoices.vue